import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTime({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.65a5.64 5.64 0 110-11.3 5.64 5.64 0 010 11.3zm2.45-2.43l-3.1-2.26a.34.34 0 01-.14-.28V4.05c0-.19.15-.34.34-.34h.9c.19 0 .34.15.34.34v4l2.6 1.9c.14.1.17.31.06.47l-.53.73a.34.34 0 01-.47.07z" />
    </svg>
  );
}

SvgBasicTime.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTime.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicTime svgRef={ref} {...props} />);
export default ForwardRef;
